// extracted by mini-css-extract-plugin
module.exports = {"session":"board_write_session__O03lb","form":"board_write_form__2w3h3","title":"board_write_title__2yOws","content":"board_write_content__2zJDY","btn":"board_write_btn__1YIoW"};